/** @jsx jsx */

import { formatDistanceToNowStrict } from 'date-fns';

import { Tooltip, TooltipFocusableTrigger } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import { useQueryAnalytics } from 'app/developer-v3/hooks';

type Props = {
  integrationId: number;
  version: string;
};

function ZapCount({ integrationId, version }: Props) {
  const { isLoading, data } = useQueryAnalytics({
    integrationId,
    version,
  });

  const countLiveZaps = data?.app?.[0]?.zapsLive ?? 0;
  const timestamp = data?.timestamp;

  return isLoading ? null : (
    <Tooltip
      allowMultiline={true}
      content={
        timestamp
          ? `Count of live Zaps that are currently turned on. Updated ${formatDistanceToNowStrict(
              timestamp * 1000,
              { addSuffix: true }
            )}.`
          : 'Count of live Zaps that are currently turned on.'
      }
    >
      <TooltipFocusableTrigger>
        <span aria-label="Zap count">{countLiveZaps}</span>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}

export default ZapCount;
